import Hotjar from '@hotjar/browser';
import { Buffer } from 'buffer';
import { STAGE } from 'constants/api';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { initSegment } from 'segment';
import VConsole from 'vconsole';
import App from './App';
import { HOTJAR_ID } from './configurations';
import './i18n';
import './index.css';

window.global = window.global ?? window;
window.Buffer = window.Buffer ?? Buffer;
window.process = window.process ?? { env: {} };

if (HOTJAR_ID) {
  Hotjar.init(+HOTJAR_ID, 6);
}

initSegment();

if (STAGE === 'development') {
  const vConsole = new VConsole();
}

if (STAGE === 'production') {
  require('./tag');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const Router = STAGE === 'development' ? BrowserRouter : BrowserRouter;

root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
